const ONLINE_WAIT_MS = 30000;
const RETRY_DELAYS_MS = [1200, 2500];

const delay = (milliseconds) => new Promise((resolve) => {
    window.setTimeout(resolve, milliseconds);
});

const waitUntilOnline = () => new Promise((resolve) => {
    if (typeof navigator === 'undefined' || navigator.onLine !== false) {
        resolve(true);
        return;
    }

    let timer;
    const cleanup = () => {
        window.removeEventListener('online', handleOnline);
        window.clearTimeout(timer);
    };
    const handleOnline = () => {
        cleanup();
        resolve(true);
    };
    timer = window.setTimeout(() => {
        cleanup();
        resolve(false);
    }, ONLINE_WAIT_MS);
    window.addEventListener('online', handleOnline, { once: true });
});

export const createExecutionRequestId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `sales-${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`;
};

export const executeWithNetworkRetry = async (request, onWaitingForNetwork) => {
    let response;
    for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt += 1) {
        response = await request();
        if (!response?.isNetworkError) return response;
        if (attempt === RETRY_DELAYS_MS.length) return response;

        onWaitingForNetwork?.(attempt + 1);
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            const online = await waitUntilOnline();
            if (!online) return response;
        } else {
            await delay(RETRY_DELAYS_MS[attempt]);
        }
    }
    return response;
};
